export default {
    methods:{
        otherDatasToSet(value) {

            let option = _.find(this.field._options, {_value: value})
            if (option) {
                _.forEach(option._other_datas_to_set, (other_data) => {
                    this.$store.set(other_data.path + '/' + other_data.name, other_data.value)
                })
            }
        },
    }
}
